import type { DeviceRobot } from "@/lib/api";

const ROBOT_KIND_NAMES: Record<string, string> = {
	"agibot-g2": "AgiBot G2",
};

/** デバイスが報告したロボットの表示名 (例「AgiBot G2」)。知らない種類は種類の識別子のまま出す。 */
export function robotLabel(robot: DeviceRobot): string {
	return ROBOT_KIND_NAMES[robot.kind] ?? robot.kind;
}
